import $ from 'jquery';
import {htmlToText} from "../Helpers";

export default function About({ page }) {

    return (
        <div className="banner-section sections section-b">
            <div className="banner-layout">
                <div className="left" data-aos="fade-up" data-aos-delay={300} data-aos-duration={1000}>
                    <div className="circle-wrap"
                         data-aos="fade-right"
                         data-aos-duration={1000}
                    >
                        <span>
                            Jouw bureau voor branding<span className="dot">.</span>
                        </span>
                    </div>
                </div>
                <div className="right">
                    <h2
                        data-aos="fade-up"
                        data-aos-duration={1000}
                    >Wie wij zijn?</h2>
                    <p
                        data-aos="fade-up"
                        data-aos-duration={1000}
                    >{htmlToText(page.inhoud)}</p>
                </div>
            </div>
            <div className="shape">
                <img src="/assets/img/shape/shape-2.svg" alt="shape" />
            </div>
        </div>
    );
}
